import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';

import { useKnownSession } from './session';
import { useLatest } from './utilities/customHooks/useLatest';

/** One page view per page, sent once it is known who is looking. */
const PostHogPageViewTracker = () => {
  const location = useLocation();
  const postHog = usePostHog();
  const session = useKnownSession();
  const internalTeam = useLatest(session?.status === 'signedIn' ? session.user.isStaff : null);
  const known = session?.status === 'signedIn';

  useEffect(() => {
    try {
      if (!postHog || !known) return;

      // eslint-disable-next-line no-restricted-globals -- legacy: View As keeps who is viewing as whom here until the server holds View As (backend ask)
      const posthogDetails = localStorage.getItem('posthogdetails');

      if (posthogDetails) {
        const posthogDetailsParsed = JSON.parse(posthogDetails);
        postHog.capture('$pageview', {
          viewAsUserName: posthogDetailsParsed?.userProperties?.viewAsUserName || "",
          viewAsUserEmail: posthogDetailsParsed?.userProperties?.viewAsUserEmail || "",
          internalTeam: posthogDetailsParsed?.userProperties?.internalTeam || false,
        });
      } else {
        postHog.capture('$pageview', { internalTeam: internalTeam.current === true });
      }
    } catch {
    }
  }, [location.key, postHog, known, internalTeam]);

  return null;
};
export default PostHogPageViewTracker;
